import { Action } from '../actions/types'

const INITIAL_STATE = {
    rid: '',
    uid: '',
    date_created: '',
    plantType: null,
    survey: [],
    surveySent: false,
    diagnosisSent: false,
    notificationSent: false,
    error: {}
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Action.REQUEST_CREATE:
            const { rid, uid, date_created, plantType } = action.payload
            return {
                ...state,
                rid,
                uid,
                date_created,
                plantType
            }
        case Action.REQUEST_SURVEY_SENT:
            return {
                ...state,
                surveySent: true,
                survey: action.payload
            }
        // case Action.REQUEST_DIAGNOSIS_SENT:
        //     return {
        //         ...state,
        //         diagnosisSent: true
        //     }
        case Action.NOTIFICATION_SENT:
                return {
                    ...state,
                    notificationSent: true
                }
        case Action.REQUEST_ERROR:
                return {
                    ...state,
                    error: action.payload
                }
        case Action.REQUEST_RESET:
                return INITIAL_STATE
        default:
            return state
            }
    }